export function getLatestObjectsWithHistory(objects) {
    const objectsWithoutPredecessors = objects.filter((object) => !object.predecessor);
    const successorMap = objects.reduce((map, object) => ({ ...map, ...(object.predecessor ? { [object.predecessor._id]: object } : {}) }), {});
    Object.entries(successorMap).forEach(([predecessorId, successor]) => {
        const isPredecessorAvailable = objects.some(({ _id }) => _id === predecessorId);
        if (!isPredecessorAvailable && successor) {
            objectsWithoutPredecessors.push(successor);
        }
    });
    const latestObjects = objectsWithoutPredecessors.map((objectsWithoutPredecessor) => {
        let currentObject = objectsWithoutPredecessor;
        let nextObject = undefined;
        const history = [];
        do {
            nextObject = successorMap[currentObject._id];
            if (nextObject) {
                history.push(currentObject);
                currentObject = nextObject;
            }
        } while (nextObject);
        return { data: currentObject, history };
    });
    return latestObjects;
}
export function findPredecessor(objects, object) {
    if (!object.predecessor) {
        return undefined;
    }
    const predecessorId = object.predecessor._id;
    return objects.find((element) => element._id === predecessorId);
}
export function findSuccessor(objects, object) {
    return objects.find((element) => element.predecessor && element.predecessor._id === object._id);
}
export function findSuccessorEntity(entities, entity) {
    if (!entity.successor) {
        return undefined;
    }
    const successorId = entity.successor._id;
    return entities.find((element) => element._id === successorId);
}
export function findPredecessorEntity(entities, entity, predecessorIds) {
    while (!predecessorIds.includes(entity._id)) {
        const predecessor = entities.find((e) => e.successor?._id === entity._id);
        if (!predecessor) {
            return undefined;
        }
        entity = predecessor;
    }
    return entity;
}
//# sourceMappingURL=VersioningUtils.js.map